import {
  QuestionCircleOutlined,
  TranslationOutlined,
  LogoutOutlined,
  UserOutlined,
  TeamOutlined
} from '@ant-design/icons';
import { ProLayout } from '@ant-design/pro-components';
import { message,Tooltip,Grid, Popover} from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { Outlet,useNavigate,useLocation } from 'react-router-dom';
import { routes  } from '../router'
import {createUseStyles} from 'react-jss'
import { useLazyLogoutQuery } from '../api/customerAPI'
import { useSelector } from 'react-redux';
import ErrorPage from './errorPage'
const { useBreakpoint } = Grid;

const SIDER_WIDTH = '104px !important'
const useStyles = createUseStyles({
    layoutBox:{
        '& .ant-pro-sider-actions-list-item':{
          marginBottom:'8px'
        },
        '& .ant-layout-sider-collapsed':{
          flexBasis:SIDER_WIDTH,
          maxWidth:SIDER_WIDTH,
          width:SIDER_WIDTH,
          background:'#fff',
        },
        '& .ant-menu-vertical >.ant-menu-item':{
          height:'auto',
          marginTop:'6px !important',
          overflow:'unset'
        },
        '& .ant-layout':{
          overflow:'hidden'
        },
        '& .ant-pro-layout-content':{
          paddingBlock:'0',
          paddingInline:'40px 0px'
        },
        '& .ant-pro-sider-logo':{
          border:'none'
        },
        '& .ant-menu-item-selected':{
          background:'#8B2938',
          color:'#fff',
        },
        '& .ant-menu-light':{
          color:'#2A2A2A',
        }
    },
    menuItem:{
      display:'flex',
      flexDirection:'column',
      alignItems:'center',  
      lineHeight:'14px',
      '&>.anticon':{
        lineHeight:'1 !important',
        paddingTop:'3px'
      },
      '&.split-item':{
        marginTop:'30px !important',
        position:'relative',
        overflow:'unset',
        
        '&::before':{
          content:'""',
          width:'100%',
          height:'2px',
          background:'#8B2938',
          position:'absolute',
          top:'0px',
          borderRadius:'4px',
          transform:'translateY(-19px)'
        }
      }
    },
    menuText:{
      wordBreak:'break-all',
      whiteSpace:"normal",
      textAlign:'center',
      lineHeight:'1.2',
      padding:'2px 0',
      fontSize:'12px'
    },
    avatarMenu:{
      margin:'-8px'
    },
    avatarMenuItem:{
      padding:'4px 8px',
      background:'transparent',
      transition:'background .2s',
      cursor:'pointer',
      '&:hover':{
        background:'rgba(0, 0, 0, 0.04)'
      },
      '& >.anticon':{
        marginRight:'10px'
      }
    }

})

const languageOptions = {
  zh:{
    personalCenter:'个人中心',
    logout:'退出登录',
    help:'帮助文档'
  },
  en:{
    personalCenter:'Personal Center',
    logout:'Logout',
    help:'Help'
  },

}
const LayoutBox =  () => {
  // screens.md为true是大屏幕
  const screens = useBreakpoint();
  const language = localStorage.getItem('language')
  const [ logoutSubmit ] = useLazyLogoutQuery()
  const navigate = useNavigate()
  const styless = useStyles()
  const localtion = useLocation()

  const stroageWebLicenseId = useSelector((state)=>state.stroageData.webLicenseId)

  const [collapsed, setCollapsed] = useState(true);
  const [slideData, setSlideData] = useState([]);
  // 显示的menu
  const ROUTES = routes.find(item => item.path === `/`).children
  // 去除掉不需要显示的
  // let SIDER_DATA = ROUTES.filter(item=>{
  //   return !item.hidden && (item.isCommon || sessionStorage.getItem('webLicenseId'))
  // })

  // 获取当前页面的路由配置信息
  const ROUTE_CONFIG = useMemo(()=>ROUTES.find(item=>item.path === localtion.pathname) || {},[localtion,ROUTES]) 
  // 设置当前活动的menu(如果路由里配置的menuKey则说明这个页面属于哪个menu的子页面,menu还是高亮这个)
  const [pathname, setPathname] = useState('');

  useEffect(()=>{
    // 设置当前高亮的tab
    setPathname(ROUTE_CONFIG.menuKey || ROUTE_CONFIG.path)

  },[ROUTE_CONFIG])


  useEffect(()=>{
    const SIDER_DATA = ROUTES.filter(item=>{
      return !item.hidden && (item.isCommon || sessionStorage.getItem('webLicenseId'))
    })
    setSlideData(SIDER_DATA)
  },[stroageWebLicenseId,ROUTES])

  const collapseClick = e=>{
    setCollapsed(!collapsed)
  }

  const menuClick = (path)=>{
    if(localtion.pathname===path)return
    setPathname(path)
    navigate(path)
  }

  const logout = async ()=>{
    const {data:{message:msg,code}={}} = await logoutSubmit()
    if(code===0){
      localStorage.removeItem('userData')
      navigate(`/login`)
    }else{
      message.error(msg)
    }
  }
  const personalClick = ()=>{
    navigate('/personalCenter')
  }

  const avatarMenu = [
    {
      key: 'personalCenter',
      onClick:personalClick,
      icon: <UserOutlined />,
      label: languageOptions[language].personalCenter,
    },
    {
      key: 'logout',
      onClick:logout,
      icon: <LogoutOutlined />,
      label: languageOptions[language].logout,
    },
  ]

  return (
    <ProLayout
      logo={require('../assets/images/favicon.png')}
      className={styless.layoutBox}
      breakpoint={{
        small: 0,
        large: 992
      }}
      collapsed={collapsed}
      onCollapse={(e)=>collapseClick(e)}
      collapsedButtonRender={false}
      layout="side"
      route={{
        routes: slideData,
      }}
      location={{
        pathname,
      }}
      menu={{
        type: 'group',
        collapsedShowTitle: true,
      }}
      ErrorBoundary={ErrorPage}
      avatarProps={false}
      actionsRender={(props) => {
        return [
          <Tooltip placement="right" color='#fff' title={languageOptions[language].help} overlayClassName={'help-tootip'} >
            <QuestionCircleOutlined style={{color:'#555',fontSize:'18px'}} key="QuestionCircleOutlined" onClick={()=>{
              navigate('/help')
            }} />
          </Tooltip>,
          <TranslationOutlined style={{color:'#555',fontSize:'18px'}} key="TranslationOutlined" onClick={()=>{
            const language = localStorage.getItem('language') ==='zh'?'en':'zh'
            localStorage.setItem('language',language)
            window.location.reload()
          }} />,
          <Popover content={<div className={styless.avatarMenu}>
            {avatarMenu.map(item=>(<div key={item.key} className={styless.avatarMenuItem} onClick={item.onClick}>
              {item.icon}
              {item.label}
            </div>))}
          </div>} placement="rightTop"><TeamOutlined style={{color:'#555',fontSize:'18px'}} /></Popover>
        ];
      }}
      onMenuHeaderClick={(e) => console.log(e)}
      menuItemRender={(item) =>  (
        <div
          className={`${styless.menuItem} ${screens.md && item.name==='API Keys' && 'split-item'}`}
          onClick={()=>menuClick(item.path)}
        >
          {item.icon}
          <div className={styless.menuText}>{item.name}</div>
        </div>
      )}
    >
      <Outlet />
    </ProLayout>
  );
};
export default LayoutBox;
